WITNESS_EFFECT_CANCELLED